import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { dashboardActions } from '../../../../store/slices/dashboardSlice/dashboardSlice';

export const useModalTeamProject = () => {
    const dispatch = useDispatch();
    const { modalMode } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );

    const onHideModal = useCallback(() => {
        dispatch(dashboardActions.onModalMode(null));
    }, []);

    return { modalMode, onHideModal };
};
